export default {
  baseURL: 'http://localhost:3000/api/v2'
}
